import React, { Component } from 'react'

// ui
import Modal from '../../../components/feedback/modal'

// select media component
import SelectMediaComponent from '../../../components/select_medias'

// redux
import { connect } from 'react-redux'
import ReportActions from '../../../redux/report/actions'

class ModalSelectMedia extends Component{

    _handleOK = () => {
        this.props.dismiss()
    }

    _handleCancel = () => {
        this.props.dismiss()
    }

    _userSelectMedia = (medias) => {
        this.props.dismiss()
        this.props.updateSelectedMedia([])
        this.props.updateSelectedMedia(medias)
    }

    render(){
        const { visible } = this.props
        let { selected_Media } = this.props 
        if (!visible) selected_Media = []

        return (
            <Modal
                visible={visible}
                title="Lựa chọn tài liệu"   
                onOk={() => this._handleOK()}
                onCancel={() => this._handleCancel()}
                centered
                width={900}
                footer={
                    null
                }
            >
                <SelectMediaComponent 
                    onSuccess = {(medias) => this._userSelectMedia(medias)}
                    onCancel = {() => this._handleCancel()}
                    initMedia = {selected_Media}
                />
            </Modal>
        )
    }
}

const mapStateToProps = state => {
    return {
        visible: state.qbreport.modalSelectMediaState,
        selected_Media: state.qbreport.selected_Media
    }
}

const mapDispatchToProps = dispatch => {
    return {
        dismiss: () => {
            dispatch(ReportActions.action.dismissModalSelectMedia())
        },
        updateSelectedMedia: selected_Media => {
            dispatch(ReportActions.action.updateSelectedMedia(selected_Media))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalSelectMedia)

